module.exports = __webpack_public_path__ + "static/media/Gloves-Men.2be75a12.jpg";